export default "__VITE_ASSET__DWsIlQCc__"